import { Pipe, PipeTransform } from "@angular/core";
import { personalityMajorType } from "src/utils/utils";
import { MBTI, PersonalityMajorType } from "../interfaces/mbti";

@Pipe({
    name: 'groupChemiBackgroundColor'
})
export class GroupChemiBackgroundColorPipe implements PipeTransform {

    transform(mbti: MBTI | undefined, containerType: 'background' | 'button' = 'background') {
        if (mbti === undefined) return 'var(--white)'
        const type: PersonalityMajorType = personalityMajorType(mbti)
        if (containerType === 'background'
        ) {
            switch (type) {
                // NF
                case 'NF':
                    return '#41A696';
                // SJ
                case 'SJ':
                    return '#4675B6';
                // NT
                case 'NT':
                    return '#665498';
                // SP
                case 'SP':
                    return '#E28658';
            }
        }
        else {
            switch (type) {
                // NF
                case 'NF':
                    return '#7AC1B6';
                // SJ
                case 'SJ':
                    return '#7E9ECC';
                // NT
                case 'NT':
                    return '#9487B7';
                // SP
                case 'SP':
                    return 'rgba(247, 150, 101, 0.95)';
            }
        }

    }
}
